(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../conversation/schema", "../../location/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../conversation/schema"), require("../../location/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema, _schema2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.braindatesSchema = _exports.braindateSchema = void 0;

  /**
   * Schema for a single braindate
   * @type {schema.Entity}
   */
  var braindateSchema = new _normalizr.schema.Entity(_setting.braindateEntityKey, {
    conversation: _schema.conversationSchema,
    location: _schema2.locationSchema
  });

  /**
   * Schema for multiple braindates
   * @type {Array<schema.Entity>}
   */
  _exports.braindateSchema = braindateSchema;
  var braindatesSchema = [braindateSchema];
  _exports.braindatesSchema = braindatesSchema;
});